var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHidePermanantly(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 141812",
    transform: "translate(-8327 -3707)",
    fill: "#dc1e1e",
    stroke: "#707070",
    d: "M0 0h16v16H0z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Mask Group 1548",
    transform: "translate(8327 3707)",
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "invisible box"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 141813",
    fill: "none",
    d: "M-8327-3707h16v16h-16z"
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "icons Q2",
    fill: "#dc1e1e"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 48380",
    d: "M-8319-3705a6 6 0 1 1-6 6 6 6 0 0 1 6-6m0-1.333a7.3 7.3 0 1 0 5.2 2.133 7.333 7.333 0 0 0-5.2-2.133Z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 48381",
    d: "m-8318.067-3699 1.867-1.833a.7.7 0 0 0 .067-.9.633.633 0 0 0-1-.067l-1.867 1.867-1.867-1.867a.633.633 0 0 0-1 .067.7.7 0 0 0 .067.9l1.867 1.833-1.867 1.833a.7.7 0 0 0-.067.9.633.633 0 0 0 1 .067l1.867-1.867 1.867 1.867a.633.633 0 0 0 1-.067.7.7 0 0 0-.067-.9Z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHidePermanantly);
export default __webpack_public_path__ + "static/media/Hide_Permanantly.75d3ce2cfef5b18db0938856b3bbe4f2.svg";
export { ForwardRef as ReactComponent };